import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import '../shared.css';

const SaleDetails = () => {
    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();

    const [selectedGWPorPWP, setSelectedGWPorPWP] = useState(false);
    const [selectedSalesMan, setSelectedSalesMan] = useState('');
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedDiscType, setSelectedDiscType] = useState('');
    const [dropdownDiscTypeOptions, setDropdownDiscTypeOptions] = useState([]);
    const [selectedCardType, setSelectedCardType] = useState('');
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchDropdownDiscTypeOptions();
    }, []);

    useEffect(() => {
        fetchData('SaleApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData({ ...response.response_data.Sale, UpdatedBy: userId });
                    setInvoicedeatils(response.response_data.SaleDetails);
                    setSelectedSalesMan(response.response_data.Sale.SalesManId);
                    setSelectedCardType(response.response_data.Sale.CardType);
                    setSelectedDiscType(response.response_data.Sale.DiscTypeId);
                    setSelectedGWPorPWP(response.response_data.Sale.GWPorPWPIncluded);
                }
            })
            .catch((error) => console.error('Error fetching Sale Details:', error));
    }, [id]);

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownSalesManOptions(data))
            .catch(err => console.error('Error fetching SalesMan:', err));
    };
    const fetchDropdownDiscTypeOptions = () => {
        fetchData('SaleApi', `/DiscType/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownDiscTypeOptions(data))
            .catch(err => console.error('Error fetching DiscType:', err));
    };
    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleApi', `/CardType/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownCardTypeOptions(data))
            .catch(err => console.error('Error fetching CardType:', err));
    };

    const fmt = (val) => (val ? parseFloat(val).toFixed(2) : '0.00');

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    return (
        <Fragment>
            <div className="pg-container">

                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Sale — Details</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <Link to="/SaleIndex" className="pg-btn pg-btn-danger">
                                <CloseIcon /> Cancel
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="pg-watermark">
                    <CopyrightIcon /><b>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">

                    {/* ── Row 1: Customer / Bill Date / Bill No / Total Qty / Disc Type / Disc % ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Customer Name <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                placeholder="Customer Name" value={formData.CustomerName || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Date <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date"
                                value={formatDateForInput(formData.BillDate)} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Bill No</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.BillNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalQuantity || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Addt'l Disc Type</span>
                            <select className="pg-hcell-input pg-hcell-readonly" value={selectedDiscType} disabled>
                                <option value="">Disc Type</option>
                                {dropdownDiscTypeOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                            </select>
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                            <span className="pg-hcell-label">Addt'l Disc %</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="number"
                                value={formData.AdditionalDiscountPercentage || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Row 2: Address / GST / Phone / SalesMan / GWP ── */}
                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Address</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                placeholder="Address" value={formData.CustomerAddress || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                            <span className="pg-hcell-label">GST Number</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                placeholder="GST Number" value={formData.GSTNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Phone No <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                placeholder="Phone Number" value={formData.ContactNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Sales Man <span className="req">*</span></span>
                            <select className="pg-hcell-input pg-hcell-readonly" value={selectedSalesMan} disabled>
                                <option value="">Select Sales Man</option>
                                {dropdownSalesManOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                            </select>
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">GWP/PWP <span className="req">*</span></span>
                            <select className="pg-hcell-input pg-hcell-readonly" value={selectedGWPorPWP} disabled>
                                <option value={true}>YES</option>
                                <option value={false}>NO</option>
                            </select>
                        </div>
                    </div>

                    {/* ── Invoice detail table ── */}
                    <div className="pg-invoice-table-wrap" style={{ marginTop: 10 }}>
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th style={{ width: 40, textAlign: 'center' }}>Sl.No</th>
                                    <th style={{ width: '40%' }}>Item Name</th>
                                    <th className="right" style={{ width: '8%' }}>Qty</th>
                                    <th className="right" style={{ width: '10%' }}>MRP</th>
                                    <th className="right" style={{ width: '10%' }}>Disc %</th>
                                    <th className="right" style={{ width: '10%' }}>Addt'l Disc %</th>
                                    <th className="right" style={{ width: '12%' }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0 ? (
                                    <tr>
                                        <td colSpan={7} style={{ textAlign: 'center', padding: '12px', color: '#94a3b8' }}>
                                            No items found.
                                        </td>
                                    </tr>
                                ) : (
                                    invoicedeatils.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                            <td>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{item.Rate}</td>
                                            <td className="right">{item.DiscountPercentage}</td>
                                            <td className="right">{item.AdditionalDiscountPercentage}</td>
                                            <td className="right">{item.TotalAmount}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* ── Totals panel ── */}
                    <div className="pg-totals-panel" style={{ marginTop: 10 }}>

                        {/* Left strip: Remarks + summary key-values */}
                        <div className="pg-totals-left">
                            <div className="pg-totals-remarks">
                                <span className="pg-tsum-label">Remarks</span>
                                <input className="pg-remarks-textarea" type="text" placeholder="Remarks"
                                    value={formData.Remarks || ''} readOnly />
                            </div>
                            <div className="pg-totals-summary">
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Amount</span>
                                    <span className="pg-tsum-value">{fmt(formData.TotalAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Discount</span>
                                    <span className="pg-tsum-value">{fmt(formData.DiscountAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Cash Disc</span>
                                    <span className="pg-tsum-value">{fmt(formData.CashDiscount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">GV Amount</span>
                                    <span className="pg-tsum-value">{fmt(formData.GVAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Net Amount</span>
                                    <span className="pg-tsum-value">{fmt(formData.TaxableAmount)}</span>
                                </div>
                            </div>
                        </div>

                        {/* Right strip: GST / Grand Total / Payments */}
                        <div className="pg-totals-right">
                            <div className="pg-totals-gst-row">
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">CGST</span>
                                    <span className="pg-tgst-value">{fmt(formData.CGSTAmount)}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">SGST</span>
                                    <span className="pg-tgst-value">{fmt(formData.SGSTAmount)}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">IGST</span>
                                    <span className="pg-tgst-value">{fmt(formData.IGSTAmount)}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">Round Off</span>
                                    <span className="pg-tgst-value">{formData.RoundOff || '0.00'}</span>
                                </div>
                            </div>

                            <div className="pg-grand-total-bar">
                                <span className="pg-gt-label">Grand Total</span>
                                <span className="pg-gt-value">{fmt(formData.GrandTotal)}</span>
                            </div>

                            <div className="pg-totals-pay-row">
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">Cash <span className="req">*</span></span>
                                    <input
                                        className={`pg-tpay-input${formData.CashAmount < 0 ? ' cash-negative' : ''}`}
                                        type="text" value={fmt(formData.CashAmount)} readOnly />
                                </div>
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">Card <span className="req">*</span></span>
                                    <input className="pg-tpay-input" type="text"
                                        value={fmt(formData.CardAmount)} readOnly />
                                </div>
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">UPI / RTGS / Other <span className="req">*</span></span>
                                    <input className="pg-tpay-input" type="text"
                                        value={fmt(formData.UPIAmount)} readOnly />
                                </div>
                            </div>

                            {/* Conditional extra fields */}
                            {(formData.CardAmount > 0 || formData.UPIAmount > 0 ||
                              formData.DiscTypeId == 1 || formData.DiscTypeId == 2) && (
                                <div className="pg-tpay-extra-row">
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">Card Name <span className="req">*</span></span>
                                            <select className="pg-tpay-select" value={selectedCardType} disabled>
                                                <option value="">Select Card Type</option>
                                                {dropdownCardTypeOptions.map(o =>
                                                    <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                                            </select>
                                        </div>
                                    )}
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">Card Number <span className="req">*</span></span>
                                            <input className="pg-tpay-input" type="text"
                                                value={formData.CardNumber || ''} readOnly />
                                        </div>
                                    )}
                                    {formData.UPIAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">UPI / RTGS / Other No. <span className="req">*</span></span>
                                            <input className="pg-tpay-input" type="text"
                                                value={formData.UPINumber || ''} readOnly />
                                        </div>
                                    )}
                                    {formData.DiscTypeId == 1 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">SC Membership No. <span className="req">*</span></span>
                                            <input className="pg-tpay-input" type="text"
                                                value={formData.SCMembershipNumber || ''} readOnly />
                                        </div>
                                    )}
                                    {formData.DiscTypeId == 2 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">Voucher Number <span className="req">*</span></span>
                                            <input className="pg-tpay-input" type="text"
                                                value={formData.VoucherNumber || ''} readOnly />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ── Inter City Stock Transfer ── */}
                    <label className="pg-checkbox-label" style={{ marginTop: 6 }}>
                        <input type="checkbox" checked={formData.IsStockTransfer || false}
                            name="IsStockTransfer" disabled />
                        INTER CITY STOCK TRANSFER
                    </label>

                </div>{/* end pg-card */}

            </div>{/* end pg-container */}
        </Fragment>
    );
};

export default SaleDetails;
